import React, { useState, useEffect, useCallback } from "react";
import { Space, message, Modal, DatePicker, Input } from "antd";
import InterfaceTable from "../../Table/InterfaceTable";
import CarbonFluxTable from "./CarbonFluxTable";
import { ButtonGereral } from "../../Utils/UI/Text";
import { CloseOutlined } from "@ant-design/icons";

import "./Nfts.css";
const { RangePicker } = DatePicker;
const { Search } = Input;

const NftsBoard = ({ totalCount, nftsData, getNfts }) => {
  const [values, setValues] = useState({ page: 0, limit: 5 });
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [typeFilter, setTypeFilter] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedNftId, setSelectedNftId] = useState(null);
  const [assetCodeFilter, setAssetCodeFilter] = useState(["assigned"]);
  const fetchData = useCallback(
    async (params = {}) => {
      setLoading(true);
      try {
        const filters = {
          start_date: dateRange[0]?.format("YYYY-MM-DD"),
          finish_date: dateRange[1]?.format("YYYY-MM-DD"),
        };

        if (params.type !== null && params.type !== undefined) {
          filters.type = params.type;
        }

        if (params.asset_code !== undefined) {
          filters.asset_code = params.asset_code;
        }

        if (params.asset_code !== undefined) {
          filters.asset_code = params.asset_code;
        }

        if (params.q !== undefined && params.q !== "") {
          filters.q = params.q;
        }
        const requestParams = {
          filter: filters,
          page: params.page ?? values.page,
          limit: params.limit ?? values.limit,
        };

        if (
          params.type !== undefined &&
          params.type !== null &&
          params.asset_code === undefined
        ) {
          requestParams.type = params.type;
        }

        await getNfts(requestParams);
      } catch (error) {
        message.error("Error al cargar los datos");
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dateRange, values.page, values.limit, typeFilter, getNfts]
  );

  const handleRequest = useCallback(
    (newPagination = {}, newFilters = {}) => {
      const { current = 1, pageSize = values.limit } = newPagination;

      const newAssetCodeFilter = newFilters.assetCode || [];
      const typeFilterValues =
        newFilters.type?.length > 0 ? newFilters.type : null;

      const updatedValues = {
        page: current - 1,
        limit: pageSize,
      };

      setValues((prev) => ({ ...prev, ...updatedValues }));
      setAssetCodeFilter(newAssetCodeFilter);
      setTypeFilter(typeFilterValues);

      fetchData({
        ...updatedValues,
        type: typeFilterValues,
        asset_code: newAssetCodeFilter,
      });
    },
    [values.limit, fetchData]
  );

  const onChange = useCallback(
    (changed_values) => {
      const value = changed_values.target
        ? changed_values.target.value
        : changed_values;
      const cleanQuery = value?.trim();
      setValues((prev) => ({ ...prev, page: 0 }));
      fetchData({ q: cleanQuery, page: 0 });
    },
    [fetchData]
  );

  const handleModalOpen = useCallback((record) => {
    setSelectedNftId(record.id);
    setIsModalVisible(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  const handleDateChange = useCallback((dates) => {
    setDateRange(dates || []);
  }, []);

  useEffect(() => {
    const params = {
      page: values.page,
      limit: values.limit,
      asset_code: assetCodeFilter,
    };

    if (typeFilter !== null && typeFilter !== undefined) {
      params.type = typeFilter;
    }

    fetchData(params);
  }, [values.page, values.limit, typeFilter, assetCodeFilter, fetchData]);

  const columns = [
    {
      title: "Code",
      dataIndex: "assetCode",
      key: "assetCode",
      filters: [
        { text: "Asignado", value: "assigned" },
        { text: "Sin asignar", value: "unassigned" },
      ],
      filteredValue: assetCodeFilter.length ? assetCodeFilter : null,
      render: (text) => text,
    },

    {
      title: "Hash de Blockchain",
      dataIndex: "blockchainHash",
      key: "blockchainHash",
    },
    { title: "Hash de IPFS", dataIndex: "ipfsHash", key: "ipfsHash" },
    {
      title: "NFT/SBT",
      dataIndex: "isSbt",
      key: "type",
      filters: [
        { text: "NFT", value: "is_nft" },
        { text: "SBT", value: "is_sbt" },
      ],
      render: (text) => text,
      filteredValue: typeFilter,
    },
    { title: "Proyecto", dataIndex: "projectName", key: "projectName" },
    { title: "Usuario", dataIndex: "username", key: "username" },
    {
      title: "Fecha de compra",
      dataIndex: "boughtAt",
      key: "boughtAt",
      render: (boughtAt) => (boughtAt ? boughtAt.slice(0, 10) : "N/A"),
    },
    { title: "Fecha de Offset", dataIndex: "usedAt", key: "usedAt" },
    { title: "Usado por", dataIndex: "usedBy", key: "usedBy" },
    {
      title: "Periodo de Offset",
      dataIndex: "offsetPeriod",
      key: "offsetPeriod",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <ButtonGereral
            text="Ver CarbonFlux"
            onClick={() => handleModalOpen(record)}
          />
          {record.isSbt === "SBT" && (
            <ButtonGereral
              href={record.certificate}
              target="_blank"
              text="Ver Certificado"
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="script-filters">
        <div>
          <RangePicker
            onChange={handleDateChange}
            placeholder={["Fecha de inicio", "Fecha de fin"]}
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <Search
            placeholder="Filter by code"
            onSearch={onChange}
            onChange={onChange}
            enterButton
            allowClear={{
              clearIcon: (
                <CloseOutlined style={{ color: "#666", fontSize: "14px" }} />
              ),
            }}
          />
        </div>
      </div>
      <div className="grid-script">
        <InterfaceTable
          rowKey="id"
          onChange={handleRequest}
          pagination={{
            pageSize: values.limit,
            current: values.page + 1,
            total: totalCount,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50", "100"],
            onShowSizeChange: (_, size) => {
              setValues((prev) => ({ ...prev, limit: size, page: 0 }));
            },
          }}
          data={nftsData}
          columns={columns}
          loading={loading}
        />
        <Modal
          title="Información de CarbonFluxes"
          visible={isModalVisible}
          onCancel={handleModalClose}
          footer={null}
          width="95%"
        >
          <CarbonFluxTable id={selectedNftId} />
        </Modal>
      </div>
    </>
  );
};

export default NftsBoard;
